<div class="min-h-screen p-6 md:p-10 space-y-6 bg-primary-50">

  <!-- Header -->
  <header class="flex items-center gap-4">
    <button type="button"
            (click)="back()"
            class="inline-flex items-center justify-center w-20 h-20 rounded-xl border border-primary-200 hover:bg-gray-50 focus:outline-none focus:ring"
            aria-label="Back to Manage">
      <i class="pi pi-arrow-left !text-5xl"></i>
    </button>
    <div class="flex-1">
      <h1 class="text-2xl md:text-3xl font-bold tracking-tight">Manage Spaces</h1>
      <p class="text-sm text-gray-500">List, switch, edit, and create your Spaces</p>
    </div>
  </header>

  <div class="max-w-xl rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
    <app-space-picker />
  </div>

</div>
